import { render, staticRenderFns } from "./LayersCacheSettings.vue?vue&type=template&id=44a1b26a&"
import script from "./LayersCacheSettings.vue?vue&type=script&lang=js&"
export * from "./LayersCacheSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports